import ApiService from '@/service/apiService';
import Api from '@/config/api';

export default {
  namespaced: true,
  state: {
    allJDs: [],
    matchedJDs: [],
    selectedJd: null,
    loading: false,
    filterState: {
      jdSearchAnd: '',
      jdSearchOr: '',
      sortBy: '',
      sortKey: null,
      asc: true,
      pageNumber: 1,
      totalPages: 1,
    },
    jdSelectors: {},
    jd_client_status: [
      '未判定',
      'スカウト対象',
      '確認依頼中',
      'スカウト済',
      '返信有',
      '応募有',
    ],
    selectedDateRange: '',
    fromAgeModel: '',
    toAgeModel: '',
    fromIncomeModel: '',
    toIncomeModel: '',
    childJobModel: [],
    mainJobModel: [],
    englishSkillModel: [],
    statusModel: [],
    manuallyCheckedJobs: [],
    finalEducationModel: [],
    shouldTriggerSearch: false,
  },

  getters: {
    getAllJDs(state) {
      return state.allJDs;
    },
    getAllMatchedJds(state) {
      return state.matchedJDs;
    },
    getJdFilterState(state) {
      return state.filterState;
    },
    getSelectedDateRange(state) {
      return state.selectedDateRange;
    },
    getFromAgeModel(state) {
      return state.fromAgeModel;
    },
    getToAgeModel(state) {
      return state.toAgeModel;
    },
    getFromIncomeModel(state) {
      return state.fromIncomeModel;
    },
    getToIncomeModel(state) {
      return state.toIncomeModel;
    },
    getJdClientStatus(state) {
      return state.jd_client_status;
    },
    getChildJobModel(state) {
      return state.childJobModel;
    },
    getMainJobModel(state) {
      return state.mainJobModel;
    },
    getFinalEducationModel(state) {
      return state.finalEducationModel;
    },
    getEnglishSkillModel(state) {
      return state.englishSkillModel;
    },
    getStatusModel(state) {
      return state.statusModel;
    },
    getCurrentPage(state) {
      return state.filterState.pageNumber;
    },
    getTotalPages(state) {
      return state.filterState.totalPages;
    },
    getSelectedJd(state) {
      return state.selectedJd;
    },
    getLoading(state) {
      return state.loading;
    },
    getShouldTriggerSearch: (state) => state.shouldTriggerSearch,
  },

  mutations: {
    setSelectedJd(state, payload) {
      state.selectedJd = payload;
    },
    setJdSelectors(state, payload) {
      state.jdSelectors = payload;
    },
    setAllJds(state, payload) {
      state.allJDs = payload;
    },
    setAllMatchedJds(state, payload) {
      state.matchedJDs = payload;
    },
    setSelectedDateRange(state, payload) {
      state.selectedDateRange = payload;
    },
    setFromAgeModel(state, payload) {
      state.fromAgeModel = payload;
    },
    setToAgeModel(state, payload) {
      state.toAgeModel = payload;
    },
    setFromIncomeModel(state, payload) {
      state.fromIncomeModel = payload;
    },
    setToIncomeModel(state, payload) {
      state.toIncomeModel = payload;
    },
    setChildJobModel(state, payload) {
      state.childJobModel = payload;
    },
    setMainJobModel(state, payload) {
      state.mainJobModel = payload;
    },
    setFinalEducationModel(state, payload) {
      state.finalEducationModel = payload;
    },
    setEnglishSkillModel(state, payload) {
      state.englishSkillModel = payload;
    },
    setManuallyCheckedJobs(state, payload) {
      state.manuallyCheckedJobs = payload;
    },
    setStatusModel(state, payload) {
      state.statusModel = payload;
    },
    clearAllJds(state) {
      state.allJDs = [];
    },
    setJdPage(state, page) {
      state.filterState.pageNumber = page;
    },
    setTotalPages(state, total) {
      state.filterState.totalPages = total;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setSearchAnd(state, value) {
      state.filterState.jdSearchAnd = value;
    },
    setSearchOr(state, value) {
      state.filterState.jdSearchOr = value;
    },
    setSortState(state, { sortKey, sortBy, asc }) {
      state.filterState.sortKey = sortKey;
      state.filterState.sortBy = sortBy;
      state.filterState.asc = asc;
    },
    resetFilters(state) {
      state.filterState.jdSearchAnd = '';
      state.filterState.jdSearchOr = '';
      state.filterState.pageNumber = 1;
    },
    resetSort(state) {
      state.filterState.sortBy = '';
      state.filterState.sortKey = null;
      state.filterState.asc = true;
    },
    clearAll(state) {
      state.childJobModel = [];
      state.mainJobModel = [];
      state.englishSkillModel = [];
      state.statusModel = [];
      state.finalEducationModel = [];
      state.selectedDateRange = '';
      state.fromAgeModel = '';
      state.toAgeModel = '';
      state.fromIncomeModel = '';
      state.toIncomeModel = '';
      state.filterState = {
        jdSearchAnd: '',
        jdSearchOr: '',
        sortBy: '',
        sortKey: null,
        asc: true,
        pageNumber: 1,
        totalPages: 1,
      };
    },
    setShouldTriggerSearch(state, value) {
      state.shouldTriggerSearch = value;
    },
  },
  actions: {
    async loadJdSelectors({ commit }) {
      try {
        const selectors = await ApiService.get(Api.endpoints.SELECTORS);
        // console.log(selectors);
        commit('setJdSelectors', selectors.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    async getAllJDs({ commit }, params = {}) {
      try {
        commit('setLoading', true);
        const response = await ApiService.get(
          Api.endpoints.ALL_JDS,
          {},
          params
        );
        const { jDs, totalPages } = response.data.data;
        commit('setAllJds', jDs);
        commit('setTotalPages', totalPages);
      } catch (error) {
        console.error('Error fetching JDs:', error);
      } finally {
        commit('setLoading', false);
      }
    },
  },
};
